import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { EmailPackageProvider } from '../../providers/email-package/email-package';
import { EmailPackage } from 'interfaces/email-package.model';
import { AssetProvider } from '../../providers/asset/asset';
import { Asset } from 'interfaces/asset.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EmailComposer } from '@ionic-native/email-composer';
import { FileProvider } from '../../providers/file/file';
import { AssetFile } from 'interfaces/asset-file.model';
import { TranslateService } from '@ngx-translate/core';
import { AssetType } from 'interfaces/asset-type.model';
import { SocialSharing } from '@ionic-native/social-sharing';

@IonicPage()
@Component({
  selector: 'page-email-package',
  templateUrl: 'email-package.html',
})
export class EmailPackagePage {

  emailPackages: EmailPackage[];
  selectedPackage: EmailPackage;
  attachments: Asset[];
  assets: Asset[];
  emailForm: FormGroup;
  boolEditEmail: boolean;
  isAttachment: boolean;
  emailParam: string;
  maxFileSize: number = 20; // file size in MB

  @ViewChild('recipientEmail') emailInput ;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public emailPackageService: EmailPackageProvider,
    public assetService: AssetProvider,
    private fileService: FileProvider,
    private fb: FormBuilder,
    private emailComposer: EmailComposer,
    private socialSharing: SocialSharing,
    public translate: TranslateService) 
  {
    this.emailPackages = [];
    this.attachments = [];
    this.assets = [];
    this.selectedPackage = null;
    this.boolEditEmail = false;
    this.isAttachment = true;
    this.emailParam = navParams.get('email');

    this.emailForm = this.fb.group({
      email: ['', [Validators.email]],
    });
  }

  ionViewDidLoad() {
    this.emailPackageService.getPackages().then((packages:EmailPackage[]) => {
      this.emailPackages = packages;
      if(this.emailPackages.length > 0){
        if(this.emailParam) {
          const index = this.emailPackages.findIndex(e => e.email == this.emailParam);
          this.showSelectedPackage(this.emailPackages[index]);
        } else {
          this.showSelectedPackage(this.emailPackages[0]);
        }
      }
    });
  }

  getEmailPackages(){
    return this.emailPackageService.getPackages();
  }

  getAttachments(){
    this.assetService.getAssets().then(assets => {
      this.attachments = this.filterAssetsByPackage(assets);
    });
  }

  getAttachmentSize(attachmentPath: string){
    return this.fileService.getFileSize(attachmentPath);
  }

  showSelectedPackage(emailPackage: EmailPackage){
    this.selectedPackage = emailPackage;
    this.emailForm.controls['email'].setValue(this.selectedPackage.email);   
    this.getAttachments();
  }

  setActivePackage(emailPackage: EmailPackage) {
    let activeClass = "";
    if((emailPackage != null) && (this.selectedPackage.email == emailPackage.email)){
      activeClass = "active";
    }
    return activeClass;
  }

  showAlertDeletePackage(){
    this.translate.get(['EMAIL_PACKAGE.DELETE_PACKAGE_TITLE', 'EMAIL_PACKAGE.DELETE_PACKAGE_TEXT', 'GENERAL.YES', 'GENERAL.NO']).subscribe(text => {
      const confirm = this.alertCtrl.create({
        title: text["EMAIL_PACKAGE.DELETE_PACKAGE_TITLE"],
        message: text["EMAIL_PACKAGE.DELETE_PACKAGE_TEXT"],
        buttons: [
          {
            text: text["GENERAL.NO"],
            handler: () => {
              console.log('No clicked');
            }
          },
          {
            text: text["GENERAL.YES"],
            handler: () => {
              console.log('Yes clicked');
              this.deletePackage();
            }
          }
        ]
      });
      confirm.present();
    });
  }

  deletePackage(){
    this.emailPackageService.deletePackage(this.selectedPackage.id).then((emailPackages: EmailPackage[]) => {
      this.emailPackages = emailPackages;
      if(this.emailPackages.length > 0){
        this.showSelectedPackage(this.emailPackages[0]);
      } else {
        this.selectedPackage = null;
        this.attachments = [];
      }

      this.translate.get(['EMAIL_PACKAGE.DELETE_PACKAGE_SUCCESS']).subscribe(text => {
        this.showToast(text["EMAIL_PACKAGE.DELETE_PACKAGE_SUCCESS"]);
      });
    })
    .catch(err => {
      this.translate.get(['EMAIL_PACKAGE.DELETE_PACKAGE_ERROR']).subscribe(text => {
        this.showToast(text["EMAIL_PACKAGE.DELETE_PACKAGE_ERROR"]);
      });
    });
  }

  showAlertRemoveAttachment(attachment: Asset){
    this.translate.get(['EMAIL_PACKAGE.DELETE_ATTACHMENT_TITLE', 'EMAIL_PACKAGE.DELETE_ATTACHMENT_TEXT', 'GENERAL.YES', 'GENERAL.NO']).subscribe(text => {
      const confirm = this.alertCtrl.create({
        title: text["EMAIL_PACKAGE.DELETE_ATTACHMENT_TITLE"],
        message: text["EMAIL_PACKAGE.DELETE_ATTACHMENT_TEXT"],
        buttons: [
          {
            text: text["GENERAL.NO"],
            handler: () => {
              console.log('No clicked');
            }
          },
          {
            text: text["GENERAL.YES"],
            handler: () => {
              this.deleteAttachment(attachment);
            }
          }
        ]
      });
      confirm.present();
    });
  }

  deleteAttachment(attachment: Asset){
    const indexAttachment = this.selectedPackage.attachments.findIndex(att => att == attachment.AssetId);
    if(indexAttachment !== -1) {
      this.subDeletedAttachmentFromPackageSize(attachment).then(() => {
        this.selectedPackage.attachments.splice(indexAttachment, 1);
        this.emailPackageService.updatePackage(this.selectedPackage).then((emailPackages: EmailPackage[]) => {
          this.emailPackages = emailPackages;
          this.getAttachments();
          this.translate.get(['EMAIL_PACKAGE.DELETE_ATTACHMENT_SUCCESS']).subscribe(text => {
            this.showToast(text["EMAIL_PACKAGE.DELETE_ATTACHMENT_SUCCESS"]);
          });
        })
        .catch(err => {
          this.translate.get(['EMAIL_PACKAGE.DELETE_ATTACHMENT_ERROR']).subscribe(text => {
            this.showToast(text["EMAIL_PACKAGE.DELETE_ATTACHMENT_ERROR"]);
          });
        });
      });

    }
  }

  subDeletedAttachmentFromPackageSize(attachment: Asset){
    return new Promise((resolve, reject) => {
      this.setAttachmentPath(attachment).then((attachmentPath: string) => {
        this.getAttachmentSize(attachmentPath).then((attachmentSize: number) => {

          if(this.selectedPackage.attachments.length > 1){
            this.selectedPackage.size -= attachmentSize;
          } else {
            this.selectedPackage.size = 0;
          }
          resolve(this.selectedPackage.size);

        });
      });
    });
  }

  editRecipientEmail(){
    this.boolEditEmail = !this.boolEditEmail;
    if (this.boolEditEmail) {
      setTimeout(() => {
        this.emailInput.setFocus();
      }, 500);
    }
  }

  filterAssetsByPackage(assets: Asset[]) {
    return assets.filter(asset => {
      return (this.selectedPackage.attachments.indexOf(asset.AssetId) > -1)
    });
  }

  setAttachmentPath(attachment: Asset){
    return this.assetService.getAssetTypeForAsset(attachment.AssetTypeId).then((assetType: AssetType) => {
      return this.fileService.getFileAssetUrl(attachment.AssetFile, assetType.AssetTypeCode).then((assetPaths: AssetFile) => {
        return assetPaths.AssetPath;
      });
    });
  }

  sendVisitorPackage(){
    let promises = [];
    
    this.attachments.forEach((attachment) => {
      promises.push(this.setAttachmentPath(attachment));
    });
    Promise.all(promises).then((result) => {
      const email = {
        to: this.selectedPackage.email,
        attachments: result
      };

      //Create email and then ask user to delete package
      this.emailComposer.open(email).then(() => this.showAlertDeletePackage(), () => this.showAlertDeletePackage());
    });
  }

  shareVisitorPackage(event: MouseEvent){
    let promises = [];
    
    this.attachments.forEach((attachment) => {
      promises.push(this.setAttachmentPath(attachment));
    });
    Promise.all(promises).then((result) => {
      var options = {
        files: result, // an array of filenames either locally or remotely
        iPadCoordinates: event.x+','+(event.y+30)+',0,0' //IOS only iPadCoordinates for where the popover should be point.  Format with x,y,width,height
      };
      
      this.socialSharing.shareWithOptions(options).then((result) => {
        if (result.completed) {
          this.showAlertDeletePackage();
        }
      }).catch((msg) => {
        console.log("Sharing failed with message: " + msg);
      });
    });
  }

  formSubmit({value, valid}){
    const newEmail = value.email

    if (valid) {
      this.selectedPackage.email = newEmail;
      this.emailPackageService.updatePackage(this.selectedPackage).then((emailPackages: EmailPackage[]) => {
        this.emailPackages = emailPackages;
        this.translate.get(['EMAIL_PACKAGE.UPDATE_RECIPIENT_EMAIL_SUCCESS']).subscribe(text => {
          this.showToast(text["EMAIL_PACKAGE.UPDATE_RECIPIENT_EMAIL_SUCCESS"]);
        });
        this.cancelEditRecipientEmail();
      })
      .catch(err => {
        this.translate.get(['EMAIL_PACKAGE.UPDATE_RECIPIENT_EMAIL_FAILED']).subscribe(text => {
          this.showToast(text["EMAIL_PACKAGE.UPDATE_RECIPIENT_EMAIL_FAILED"]);
        });
      });
    }
  }

  cancelEditRecipientEmail(){
    this.boolEditEmail = !this.boolEditEmail;
    this.emailForm.controls['email'].setValue(this.selectedPackage.email);
  }

  async showToast(msg: string) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000
    });
    toast.present();
  }

  async showAlert(msg: string) {
    const alert = await this.alertCtrl.create({
      message: msg,
      buttons: ['OK']
    });
    alert.present();
  }

  convertInMegaBytes(packageSize: number){
    return (packageSize / 1048576).toFixed(2);;
  }

}



// WEBPACK FOOTER //
// ./src/pages/email-package/email-package.ts